import mockClientData from './mock_client_data.json';

export const USE_MOCK_SHIPMENT_DATA = true;

export const SHIPMENT_STORAGE_KEYS = {
    estimateNumber: 'estimativa_numero',
    clientData: 'cliente_data'
};

export const SHIPMENT_EMPTY_VALUE = '---';

export const SHIPMENT_FALLBACK_CLIENT_DATA = {
    cnpj: '12.345.678/0001-90',
    nome: 'Joao Silva',
    empresa: 'Empresa Exemplo Ltda',
    telefone: '(11) 99999-9999',
    email: 'joao@empresa.com'
};

export const SHIPMENT_MOCK_CLIENT_DATA = mockClientData;

export const SHIPMENT_INVOICE_RECIPIENT = {
    cnpj: '43.854.777/0001-26',
    ie: '246.054.622.118',
    companyName: 'BUNZL EQUIPAMENTOS PARA PROTECAO INDIVIDUAL LTDA',
    addressLines: [
        'Estrada Velha Guarulhos Sao Miguel, 5135',
        'Jardim Arapongas, Guarulhos - SP, CEP: 07210-250'
    ]
};
